/**
 * Derive up-to-two-character initials from a display name or fallback string.
 * Single-word inputs return the first two characters of that word.
 * Empty / whitespace-only inputs return "?".
 */
const getInitials = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return '?';
  }
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export default getInitials;
